import PropTypes from 'prop-types';

/** Components */
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import { replaceH1withH2 } from 'utils/functions';

const categoryDescriptionDefaultPropSx = {};

const categoryDescriptionDefaultPropCategory = {
  description: '',
};

const CategoryDescription = ({
  category = categoryDescriptionDefaultPropCategory,
  loading = false,
  sx = categoryDescriptionDefaultPropSx,
}) => {
  return (
    <Grid container sx={{ ...sx }}>
      <Grid xs={12} item sx={{ textAlign: 'left' }} mb={1}>
        {loading ? (
          <>
            <Skeleton sx={{ my: 0.25 }} />
            <Skeleton sx={{ my: 0.25 }} />
            <Skeleton sx={{ my: 0.25 }} />
            <Skeleton sx={{ my: 0.25 }} />
            <Skeleton sx={{ my: 0.25 }} />
          </>
        ) : (
          <>
            <Typography component="h2" variant="h6">
              Shop Wholesale {category?.name} from Independent Suppliers in the UK, Europe and the US.
            </Typography>
            <Typography
              variant="body2"
              component="div"
              dangerouslySetInnerHTML={{ __html: category?.description ? replaceH1withH2(category?.description) : '' }}
            />
          </>
        )}
      </Grid>
    </Grid>
  );
};

CategoryDescription.propTypes = {
  sx: PropTypes.shape({}),
  category: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
  }),
  loading: PropTypes.bool,
};

export default CategoryDescription;
